import { FieldErrors } from "react-hook-form";

type FindFirstInvalidRhfFieldProps = {
  errors: FieldErrors;
  fieldOrder: string[];
};

export const findFirstInvalidRhfField = ({ errors, fieldOrder }: FindFirstInvalidRhfFieldProps): string | undefined => {
  return fieldOrder.find((fieldName) => errors?.[fieldName] != null);
};
